import { getStore } from '~/mobx/AppStore';
import regionApi from '~/clientApis/regionApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { FETCH_REGION_ERROR } from '~/consts/errorMessages';

const getRegions = async () => {
    const { electionMenuStore, generalSettingsStore, regionStore } = getStore();
    const { selectedElectionId } = generalSettingsStore;

    if (!selectedElectionId) {
        return;
    }

    generalSettingsStore.setIsLoadingElectionList(true);

    try {
        const regions = await regionApi.getRegionList(selectedElectionId);
        electionMenuStore.setRegions(regions);
        regionStore.setRegions(regions);
    } catch {
        showMessageModal('error', FETCH_REGION_ERROR);
    } finally {
        generalSettingsStore.setIsLoadingElectionList(false);
    }
};

export default getRegions;
